<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Szűrő</h1>

          <div class="row">
            <div class="col-xs-2">
              <comboboxV2 @input="getElements" id="element_type" label="Típus" name="element_type" v-model="element_type" :options="element_types"></combobox>
            </div>
          </div>

          <div v-if="element_type != 0" class="infobox">
            <i class="icon fa fa-info-circle"></i>
            <span class="highlight">Figyelem!</span> Típus váltás előtt menteni kell a beállított értékeket!
          </div>

          <div v-if="this.elements.length > 0" class="table-with-title">
            <h2>Elemek</h2>
            <table class="list">
              <thead>
                <tr>
                  <th style="width: 100px;">ID</th>
                  <th style="width: 200px;">Megnevezés</th>
                  <th style="width: 200px;">Csoport</th>
                  <th>Felhasználók</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="element in elements">
                  <td>{{element.element_id}}</td>
                  <td>{{element.name}}</td>
                  <td>{{element.group}}</td>
                  <td>
                    <select2 multi="true" :key="'user_'+element.element_id" :name="'user_'+element.element_id" :id="'user_'+element.element_id" :options="users" v-model="element.user_ids"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  components: {
  },

  data: function() {
    return {
      element_type: 0,
      element_types: [],
      users: [],
      elements: [],
      is_save: false
    }
  },

  mounted: function() {
    this.getElementTypes();
  },

  methods: {
    save: function() {
      var _this = this;
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('filter/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: {
            elements: JSON.stringify(_this.elements)
          },
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;
          }
        });
      });
    },

    getElementTypes: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('filter/element_types_and_users/' + _this.$root.user.apikey, {
          method: 'get',
          success: function(response) {
            _this.element_types = response.types;
            _this.users = response.users;
          }
        });
      });
    },

    getElements: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('filter/elements/' + _this.$root.user.apikey + '/' + _this.element_type, {
          method: 'get',
          success: function(response) {
            _this.elements = response.elements;
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// filter.vue?6ff96138